import React, { useEffect } from 'react';
import { useParams, useSearchParams } from "react-router-dom";
import { fetchPosts } from "src/actions/community/postsActions";
import { useAppDispatch } from "src/store/hooks";
import { queryParams } from "src/helpers/UrlHelpers";
import communityUrls from "src/configs/community/communityUrls";

import PageLayout from "../_partials/PageLayout";
import PageHeader from "../Posts/_partials/_PageHeader";
import List from "../Posts/_partials/_List";
import New from "../Posts/New";
import Wrapper from "src/componets/Wrapper";
import Filter, { FilterInterface } from "src/componets/Filter";
import ListViewButtons from "src/componets/ListViewButtons";
import { fetchCategories } from "src/actions/community/categoriesActions";
import NewCategory from "../Categories/New";
import EditCategory from "../Categories/Edit";
import CategoriesSettings from "../Categories/Settings";
import MenuCategories from "../Categories/_partials/_MenuCategories";

const NAV_ITEMS: {[index: number]: any} = {};
const LIMIT = 42;
const DEFAULT_VIEW = 'grid';
const TARGET = 'community';

const Community = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const categoryId = queryParams.getInt(searchParams,'category_id');
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const listType: any = queryParams.get(searchParams,'view') || DEFAULT_VIEW;
  const filterProps: FilterInterface = {};
  const { app_id } = useParams();

  useEffect(() => {
    const params: any = queryParams.requestParams(
        searchParams,
        {
          app_id: app_id,
          limit: LIMIT,
          offset: (currentPage - 1) * LIMIT
        },
        ['term', 'order_by', 'order', 'date_from', 'date_to']
    );

    if (categoryId) {
      params.category_id = categoryId;
    }

    dispatch(fetchPosts({ params, target: TARGET }));
    dispatch(fetchCategories({ params: { app_id: app_id, target: TARGET } }));
  }, [categoryId, app_id, searchParams, currentPage, dispatch]);

  filterProps.orderBy = {
    defaultKey: 'id',
    defaultSort: 'desc',
    items: [
      { name: 'Date',       key: 'id' },
      { name: 'Popular',    key: 'popular_count' },
      { name: 'Trending',   key: 'trending' },
      { name: 'Likes',      key: 'likes_count' },
      { name: 'Comments',   key: 'comments_count' },
      { name: 'Downloads',  key: 'downloads_count' },
    ]
  };

  return (
      <PageLayout>
        <PageHeader
          title={'Community'}
          navs={NAV_ITEMS}
          target={TARGET}
          parent={{
            name: 'All',
            url: communityUrls.communityPath()
          }}
        />

        <div className='v-container'>
          <Wrapper type='type-1' border className='v-mb-10'>
            <Filter
              search
              dateRange
              {...filterProps}
            >
              <ListViewButtons className='v-mb-5' align='right' defaultType={DEFAULT_VIEW} />
              <MenuCategories />
            </Filter>
          </Wrapper>

          <List limit={LIMIT} pagination={true} type={listType} />

          <New />

          <NewCategory />
          <EditCategory />
          <CategoriesSettings />
        </div>
      </PageLayout>
  );
}

export default Community;
